import { LanguageDropdown, Link, UserDropdown } from ".";
import cn from "classnames";
import { isUserLoggedIn } from "../redux/auth-slice";
import sharedStyles from "../shared.module.scss";
import styles from "./Header.module.scss";
import { useSelector } from "react-redux";

export function Header({ hideMenu }) {
  const isLoggedIn = useSelector(isUserLoggedIn);

  return (
    <header className={cn(styles.header, sharedStyles.content)}>
      <div className={styles.container}>
        <Link to="/" className={styles.homeLink}>
          <img src="/logo_header.png" alt="logo" className={styles.logo} />
        </Link>
        {!hideMenu && (isLoggedIn ? <UserDropdown /> : <LanguageDropdown />)}
      </div>
    </header>
  );
}
